import React from 'react';
import * as ICONS from '../../../../images/react';
import { COLORS } from '../ui.constants';

export type ValidIcon = keyof Omit<typeof ICONS, 'IIconProps'>;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: keyof typeof COLORS | (string & {});
  icon: ValidIcon;
  size?: string | number;
}

interface AdditionalProps {
  initialsText?: string;
  secondaryColor?: string;
}

const Icon = React.forwardRef<SVGSVGElement, IconProps & AdditionalProps>(({
  color, height, icon, size, width, ...rest
}, ref) => {
  const IconComponent = ICONS[icon];

  return (
    <IconComponent
      ref={ref}
      aria-hidden
      color={COLORS[color] || color}
      height={size ?? height}
      width={size ?? width}
      {...rest}
    />
  );
});

Icon.displayName = 'Icon';

export default Icon;
